// extracted by mini-css-extract-plugin
export default {"publishingOptionsImageDimensions":"IoDcRQQLZVTyLMkk0P75"};